function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { i18n } from "../../services";
import { signature } from "../../services";

var initializeSignatureStack = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var stack, metadataStacks;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            stack = sessionStorage.getItem('portal.signature.stack');

            if (stack) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return signature.getMetadataStacks();

          case 4:
            metadataStacks = _context.sent;
            sessionStorage.setItem('portal.signature.stack', JSON.stringify(metadataStacks["default"]));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initializeSignatureStack() {
    return _ref.apply(this, arguments);
  };
}();

export var initializeSignatureSettings = function initializeSignatureSettings() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var _yield$signature$getM, defaultRecipientLanguage, defaultSignatureMethods;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return initializeSignatureStack();

            case 2:
              _context2.next = 4;
              return signature.getModuleSettings();

            case 4:
              _yield$signature$getM = _context2.sent;
              defaultRecipientLanguage = _yield$signature$getM.defaultRecipientLanguage;
              defaultSignatureMethods = _yield$signature$getM.defaultSignatureMethods;
              dispatch({
                type: 'SET_SIGNATURE_SETTINGS',
                value: {
                  defaultRecipientLanguage: defaultRecipientLanguage,
                  defaultSignatureMethods: defaultSignatureMethods
                }
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getDictionary = function getDictionary(language) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      var dictionary;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return i18n.getDictionary(language);

            case 2:
              dictionary = _context3.sent;
              dispatch({
                type: 'SET_DICTIONARY',
                value: {
                  language: language,
                  data: dictionary
                }
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var setTranslationMissing = function setTranslationMissing(translationMissing) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch({
                type: 'UPDATE_TRANSLATION_MISSING',
                translationMissing: translationMissing
              });

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var setLanguage = function setLanguage(language) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch({
                type: 'SET_LANGUAGE',
                language: language
              });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export default {
  getDictionary: getDictionary,
  setLanguage: setLanguage,
  initializeSignatureSettings: initializeSignatureSettings,
  setTranslationMissing: setTranslationMissing
};